import Glide from '@glidejs/glide';

let glide = new Glide('.glide-videos', {
  type: 'carousel',
  perView: 2,
  focusAt: 'center',
  // autoplay: 8000,
  breakpoints: {
    1000: {
      perView: 1,
      autoplay: false
    }
  },
});
glide.mount();

document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  let slideNum = parseInt(params.get('session'));
  if (slideNum >= 1 && slideNum <= 6) {
    slideNum--;
    glide.go(`=${slideNum}`);
  }
});

